<div class="multi-select3">

  <div class="multi-select3__header">
    <div class="search">
      <mat-icon class="search__icon">search</mat-icon>
      <input class="search__input" [placeholder]="title" [(ngModel)]="searchTerm">
    </div>
    <mat-icon class="add" (click)="openDialog()">add</mat-icon>
  </div>

  <div class="checkbox-list" cdkDropList (cdkDropListDropped)="drop($event)">
    @for (item of filteredItems(); track item.id) {
      <div class="item" cdkDrag>
        <mat-icon (click)="removeItem(item)">close</mat-icon>
<!--        <span>{{ item.name }}</span>-->
        <ng-container *ngTemplateOutlet="listItem; context: {$implicit: item}"></ng-container>
      </div>
    }
  </div>
</div>

